import { render, staticRenderFns } from "./TablaCategoriasComponent.vue?vue&type=template&id=506fb92a&scoped=true"
import script from "./TablaCategoriasComponent.vue?vue&type=script&lang=js"
export * from "./TablaCategoriasComponent.vue?vue&type=script&lang=js"
import style0 from "./TablaCategoriasComponent.vue?vue&type=style&index=0&id=506fb92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506fb92a",
  null
  
)

export default component.exports